var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8071 0.841553H6.81133C8.479 0.841553 9.4778 1.85431 9.48232 3.54531V8.51746C9.48232 10.2085 8.48804 11.2212 6.81585 11.2212H5.33347C5.14336 11.2 4.99947 11.0371 4.99947 10.8431C4.99947 10.6492 5.14336 10.4863 5.33347 10.4651H6.81133C8.08581 10.4651 8.72757 9.80976 8.72757 8.51746V3.54531C8.72757 2.253 8.08581 1.59769 6.81133 1.59769H2.8071C1.53261 1.59769 0.886334 2.253 0.886334 3.54531V8.51746C0.886334 9.80976 1.53261 10.4651 2.8071 10.4651C2.99721 10.4863 3.1411 10.6492 3.1411 10.8431C3.1411 11.0371 2.99721 11.2 2.8071 11.2212C1.13942 11.2212 0.140625 10.2085 0.140625 8.51746V3.54531C0.140625 1.84973 1.13942 0.841553 2.8071 0.841553ZM2.93821 4.21428H4.36184C4.55195 4.19302 4.69584 4.03014 4.69584 3.83621C4.69584 3.64228 4.55195 3.4794 4.36184 3.45814H2.93821C2.74811 3.4794 2.60421 3.64228 2.60421 3.83621C2.60421 4.03014 2.74811 4.19302 2.93821 4.21428ZM6.67575 6.40933H2.93817H2.93365C2.74355 6.38807 2.59965 6.22519 2.59965 6.03126C2.59965 5.83733 2.74355 5.67445 2.93365 5.65319H6.67575C6.81876 5.63721 6.95819 5.70557 7.03464 5.82915C7.11109 5.95274 7.11109 6.10978 7.03464 6.23337C6.95819 6.35696 6.81876 6.42532 6.67575 6.40933ZM6.67598 8.60433H2.9384H2.93388C2.72921 8.60433 2.56329 8.43608 2.56329 8.22855C2.56329 8.02101 2.72921 7.85277 2.93388 7.85277H6.67598C6.88066 7.85277 7.04658 8.02101 7.04658 8.22855C7.04658 8.43608 6.88066 8.60433 6.67598 8.60433Z",
    fill: "#4D4D57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocLight);
export default __webpack_public_path__ + "static/media/doc_light.773a0d45989d3b0afde5ebdd838b86cb.svg";
export { ForwardRef as ReactComponent };